import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'lepi-label',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex gap-1.5 items-center mb-2">
      <span
        class="text-[15px] font-bold text-base-content/80 tracking-tight leading-none">
        <ng-content />
      </span>
      @if (required()) {
        <span class="w-1.5 h-1.5 rounded-full bg-primary/80 flex-none"></span>
      }
    </div>
  `,
})
export class Label {
  required = input<boolean>(false);
}
